export interface CarouselImages {
    src: string,
    alt : string,
    description: string;
}

export const carouselData: CarouselImages[] = [
  {
    src: "/img/carousel/agua1.webp",
    alt: "Contaminación del agua en cuencas hidrográficas que desembocan en el océano",
    description:
      "Las cuencas hidrográficas y el océano es el vertedero final para una gran parte de nuestros desechos",
  },
  {
    src: "/img/carousel/agua2.webp",
    alt: "Presencia de nutrientes y metales pesados en aguas continentales y marinas",
    description:
      "Los contaminantes presentes son por lo general nutrientes, metales pesados, compuestos orgánicos específicos y radionúclidos",
  },
  {
    src: "/img/carousel/agua3.webp",
    alt: "Impacto de fosfatos y nitratos en la biodiversidad de los ecosistemas acuáticos",
    description:
      "Los fosfatos, nitratos y metales pesados actúan de forma acumulativa produciendo cambios en la diversidad de los ecosistemas",
  },
  {
    src: "/img/carousel/agua4.webp",
    alt: "Sedimentación de metales pesados y pesticidas en fondos acuáticos",
    description:
      "Los metales pesados y pesticidas pasan de la columna de agua a los sedimentos de fondo",
  },
  {
    src: "/img/carousel/agua6.webp",
    alt: "Eutrofización de aguas por exceso de nitratos y fosfatos",
    description:
      "El exceso de nutrientes induce el crecimiento desmesurado de algas y provoca la eutrofización de las aguas",
  },
  {
    src: "/img/carousel/dron-image-01.webp",
    alt: "Floraciones de algas y pérdida de oxígeno en ecosistemas acuáticos",
    description:
      "Al morir las algas, la descomposición agota el oxígeno e impide la vida de otros organismos",
  },
  {
    src: "/img/carousel/dron-image-02.webp",
    alt: "Monitorización ambiental con drones en masas de agua",
    description:
      "Los contaminantes emergentes son compuestos químicos detectados recientemente en el medio ambiente",
  },
  {
    src: "/img/carousel/red-neuronal_opt.webp",
    alt: "Modelo de red neuronal para análisis ambiental y predicción de riesgos",
    description: "La biorremediación se presenta como una estrategia sostenible conduce a la mejora de los recursos hídricos y de la gestión energética, fomentando la eficiencia en su uso",
  },
  {
    src: "/img/carousel/dron_opt.webp",
    alt: "Uso de drones para análisis de datos ambientales en entornos acuáticos",
    description: "Los drones permiten recopilar datos ambientales y monitorizar la calidad del agua de forma rápida y precisa",
  },
  {
    src: "/img/carousel/galicia-embalses-alertas_opt.webp",
    alt: "Sistema de alertas y monitoreo de embalses en Galicia",
    description: "Los sistemas de alerta facilitan la vigilancia de embalses y la detección temprana de cambios en la calidad del agua",
  },
  {
    src: "/img/carousel/vsc-coding.webp",
    alt: "Desarrollo de software para análisis de datos ambientales",
    description: "El software de análisis permite procesar datos ambientales y apoyar la gestión sostenible de los recursos hídricos",
  },
];
